import React from 'react';

import {useTransformQuery} from 'web-app/react/hooks/use-transform-query';

import {GetFinanceOverviewAccess} from '../queries';
import type {
    GetFinanceOverviewAccessQuery,
    GetFinanceOverviewAccessQueryVariables,
} from '../__generated__/queries.api-types';

type Props = {
    siteId: string;
};

export const useFinanceOverviewAccess = ({siteId}: Props) => {
    const [access, {loading}] = useTransformQuery<
        GetFinanceOverviewAccessQuery,
        GetFinanceOverviewAccessQueryVariables
    >()(
        GetFinanceOverviewAccess,
        {
            variables: {siteId},
            skip: !siteId,
        },
        ({data}) => {
            return {
                isFinanceOverviewEnabled:
                    data?.finance.financeOverviewVersioned.v1.access.isFinanceOverviewEnabled ?? false,
                shouldUseBillingHub: data?.finance.financeOverviewVersioned.v1.access.shouldUseBillingHub ?? false,
            };
        },
    );

    const memoizedAccess = React.useMemo(() => {
        return {
            isFinanceOverviewEnabled: access.isFinanceOverviewEnabled,
            shouldUseBillingHub: access.shouldUseBillingHub,
            loading,
        };
    }, [access.isFinanceOverviewEnabled, access.shouldUseBillingHub, loading]);

    return memoizedAccess;
};
